import { ItemGroup } from '@nesso/ui/primitives/item';

import { ClientRelationshipCard, type GetClientRelationshipsOutput } from '@/entities/client';

type Props = {
    links: GetClientRelationshipsOutput['items'];
};

export function ClientDetailsRelationships({ links }: Props) {
    return (
        <ItemGroup className="gap-3 pt-3 pb-2">
            {links.map((link) => (
                <div key={link.clientId} role="listitem">
                    <ClientRelationshipCard link={link} />
                </div>
            ))}
        </ItemGroup>
    );
}
